import styled from "styled-components";
import { BodyMedium, BodyDefault, VerySmall } from "../typography/styled";


type ActiveProp = {
  active:boolean;
  activeResults?:boolean;
}

export const Container = styled.div<ActiveProp>`
  position: relative;
  width: ${({active}) => active ? '650px' : '330px'};
  max-width: 100%;
  min-width: 0;
  height:40px;
  transition: width 0.5s ease-in-out;
`
export const SearchWrapper = styled.div<ActiveProp>`
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 100%;
  z-index:3;
  position: relative;
  transition: width 0.5s ease-in-out;
  height: 40px;
  top:0;
  background-color: ${({theme}) => theme.palette[10]};
  padding: ${({active}) => active ? '10px' : '10px 19px 10px 10px'};
  box-shadow:${({theme, activeResults}) => activeResults ? theme.isDark ? theme.shadows.focusDark : theme.shadows.focus : theme.shadows.card};
  clip-path: ${({activeResults}) => activeResults ? 'inset(-3px -3px 0 -3px)' : 'none'};
  border-radius: ${({activeResults, theme}) => activeResults ? `${theme.radius.search} ${theme.radius.search} 0px 0px` : theme.radius.search};
  color: ${({theme}) => theme.primary[700]};
  border: ${({theme, active}) =>  active ? `1px solid ${theme.accent[100]}` : `1px solid ${theme.neutral[15]}`};
  &:hover{
    cursor: pointer;
    color: ${({theme}) => theme.primary[500]};
  }
`

export const ImgArrow = styled.img`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`
export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  z-index: 5;
`
export const Title = styled(BodyMedium)`
  color:${({theme}) => theme.neutral[100]};
  margin-left: 6px;
  margin-right: 13px;
`

export const SearchInput = styled.input<ActiveProp>`
  width: 100%;
  min-width: 0;
  flex: 1;
  border:none;
  font-size: 15px;
  outline: none;
  color:${({theme}) => theme.palette[900]};
  background-color: transparent;
  &::placeholder {
    color: ${({theme}) => theme.neutral[50]};
    opacity: 1;
  }
  &:-webkit-autofill:focus {
    -webkit-text-fill-color: ${({theme}) => theme.palette[900]};
  }
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
    -webkit-text-fill-color: ${({theme}) => theme.palette[900]};
      /* -webkit-text-fill-color: #fff !important; */
  }
`
export const Divider = styled.div<ActiveProp>`
  position: absolute;
  box-sizing: border-box;
  z-index: 5;
  /* width: 648px;
   */
  width: 100%;
  height: 15px;
  left:0px;
  top: 33px;

  background-color: ${({theme}) => theme.palette[10]};
  border-bottom: ${({theme, active}) =>  active ? `1px solid ${theme.grey[400]}` : ''};
  border-left: ${({theme, active}) =>  active ? `1px solid ${theme.accent[100]}` : ''};
  border-right: ${({theme, active}) =>  active ? `1px solid ${theme.accent[100]}` : ''};
  transition: width 0.5s ease-in-out;
`
export const DividerCategory = styled.div`
  display: none;
`

export const SearchResultsContainer = styled.div<ActiveProp>`
  visibility: ${({active}) => active ? 'visible' : 'hidden'};
  opacity: ${({active}) => active ? 1 : 0};
  pointer-events: ${({active}) => active ? 'auto' : 'none'};
  transition:
    opacity 0.1s ease-in-out,
    visibility 0s linear ${({active}) => active ? '0s' : '0.5s'};
`

export const OptionsWrapper = styled.div<ActiveProp>`
  box-sizing: border-box;
  top: 40px;
  position: absolute;
  display: flex;
  z-index:1;
  flex-direction: column;
  border-radius: ${({active, theme}) => active ? `0px 0px ${theme.radius.search} ${theme.radius.search}` : theme.radius.search};
  padding: 0px 0px 0px 8px;
  border: ${({theme}) => `1px solid ${theme.accent[100]}`};
  background-color: ${({theme}) => theme.palette[10]};
  box-shadow:${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  clip-path: inset(0 -3px -3px -3px);
  
  width: 100%;
  transition: width 0.5s ease-in-out;
  max-height: 311px;
  overflow-y: scroll;
  overflow-x: hidden;
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 2px 2px ${({theme}) => theme.isDark ? theme.palette[200] : theme.grey[400]};
    border-width: 0 2px 0 2px;
    border-color: rgba(28,28,28,0);
    border-style: solid;
    border-radius: 5px;
  }
  ::-webkit-scrollbar-track {
    margin: 12px 0 12px 0;
  }
  ::-webkit-scrollbar-button{
    display: none;
  }
`
export const DropOptionsTitle = styled(VerySmall)`
  box-sizing: border-box;
  height: 32px;
  flex-shrink: 0;
  color:${({theme}) => theme.palette[600]};
  padding: 15px 10px 2px 12px;
  text-transform: uppercase;
  font-weight: 500;
  line-height: 15px;
`

export const DropItemWrapper = styled.div`
  padding: 8px 12px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  img {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }
  &:hover{
    cursor: pointer;
     background: ${({theme}) => theme.isDark ? theme.palette[200] : theme.grey[100]};
  }
  &:active{
    background-color: ${({theme}) => theme.isDark ? theme.palette[400] : theme.grey[200]};
    transition: 0.1s background-color ease-in-out;
  }
`

export const DropOptionItem = styled(BodyDefault)`
  color:${({theme}) => theme.palette[850]};
  margin-left: 13px;
  font-size: 16px;
  line-height: 20px;
`
